import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import apiClient from './plugins/axios'
import '@mdi/font/css/materialdesignicons.css'

// Vue devtools otomatik olarak development modunda aktif olur

const app = createApp(App)

// Axios'u global olarak kullanılabilir yap
app.config.globalProperties.$api = apiClient

app
  .use(router)
  .use(vuetify)
  .mount('#app')